import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { OrderFacade } from '@symphony-solo/domain/order/src';
import { CompanyConfigFacade, CompanyConfigType } from '@symphony-solo/domain/company-config/src';
import { map } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'symphony-solo-customer-info-form',
  templateUrl: './customer-info-form.component.html',
  styleUrls: ['./customer-info-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerInfoFormComponent implements OnInit, OnDestroy {
  public viewModel$: Observable<any> = combineLatest([
    this.orderFacade.customerInfo$,
    this.companyConfigFacade.isCustomerInfoOptional$,
    this.companyConfigFacade.companyConfigIndex$,
  ]).pipe(
    map(([customerInfo, isCustomerInfoOptional, companyConfigIndex]) => {
      this.isCustomerInfoOptional = isCustomerInfoOptional;
      this.setInitialFormValues(customerInfo);
      if(companyConfigIndex) {
        this.settingCompanyConfig(companyConfigIndex);
      }
      return {
        customerInfo,
        isCustomerInfoOptional,
      };
    })
  );

  @Output() public customerInfoFormStatus: EventEmitter<any> = new EventEmitter();
  public feildsTitle = {
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  };
  public customerDetailsForm = this.fb.group({
    firstName: ['', [Validators.compose([Validators.required, Validators.pattern('^(?!-+$)[a-zA-Z-]+$')])]],
    lastName: ['', [Validators.compose([Validators.required, Validators.pattern('^(?!-+$)[a-zA-Z-]+$')])]],
    email: ['', [Validators.compose([Validators.required, Validators.email])]],
    phone: ['', [Validators.compose([Validators.required])]],
  });

  public validations = {
    firstName: [
      { type: 'required', message: 'First name is required.' },
      { type: 'pattern', message: 'Your first name must contain only alphabetic characters.' },
    ],
    lastName: [
      { type: 'required', message: 'Last name is required.' },
      { type: 'pattern', message: 'Your last name must contain only alphabetic characters.' },
    ],
    email: [
      { type: 'required', message: 'Email is required.' },
      { type: 'email', message: 'Please enter a valid email address.' },
    ],
    phone: [
      { type: 'required', message: 'Phone is required.' },
      { type: 'pattern', message: 'Please enter a valid phone no.' },
    ],
  };

  private isCustomerInfoOptional = false;

  constructor(
    public orderFacade: OrderFacade,
    private companyConfigFacade: CompanyConfigFacade,
    private cdf: ChangeDetectorRef,
    private fb: FormBuilder
  ) {}

  public ngOnInit() {}

  public submitForm() {
    if (this.isCustomerInfoOptional) {
      this.customerInfoFormStatus.emit(true);
      this.orderFacade.setCustomerInfo(this.customerDetailsForm.value);
    } else {
      this.customerDetailsForm.markAllAsTouched();
      this.customerInfoFormStatus.emit(this.customerDetailsForm.valid);
      if (this.customerDetailsForm.valid) {
        this.orderFacade.setCustomerInfo(this.customerDetailsForm.value);
      }
    }

    this.cdf.detectChanges();
  }

  public ngOnDestroy(): void {}

  private setInitialFormValues(values): void {
    if (values) {
      this.customerDetailsForm.controls['firstName'].setValue(values.firstName);
      this.customerDetailsForm.controls['lastName'].setValue(values.lastName);
      this.customerDetailsForm.controls['email'].setValue(values.email);
      this.customerDetailsForm.controls['phone'].setValue(values.phone);
    } else {
      this.customerDetailsForm.reset();
    }
  }
  private settingCompanyConfig(companyConfigIndex) {
    this.feildsTitle.firstName = companyConfigIndex[CompanyConfigType.SignupTextLabelFirstName];
    this.feildsTitle.lastName = companyConfigIndex[CompanyConfigType.SignupTextLabelLastName];
    this.feildsTitle.email = companyConfigIndex[CompanyConfigType.TextBasicEmailAddress];
    this.feildsTitle.phone = companyConfigIndex[CompanyConfigType.SignupTextLabelMobile];
    this.cdf.detectChanges();
  }
}
